import { node, bool } from 'prop-types';
import React from 'react';

const ContentColumns = ({ firstColumn, secondColumn, alignEnd, inverse = false }) => {
  const bigColumn = 4;
  const smallColumn = 2;

  const firstColumnSize = inverse ? smallColumn : bigColumn;
  const secondColumnSize = inverse ? bigColumn : smallColumn;

  return (
    <div style={{ display: 'flex', alignItems: alignEnd ? 'flex-end' : 'flex-start' }}>
      <div style={{ flex: firstColumnSize, paddingRight: '2rem' }}>{firstColumn}</div>
      <div style={{ flex: secondColumnSize }}>{secondColumn}</div>
    </div>
  );
};

ContentColumns.propTypes = {
  firstColumn: node,
  secondColumn: node,
  alignEnd: bool,
  inverse: bool,
};

export default ContentColumns;
